export const LOI_TOKEN_COOKIENAME = 'ergo_loi';
export const AKTIONSNUMMER_COOKIENAME = 'aktionNr';

export const extractCookieValue = (cookieName: string): string => {
  const decodedCookieString = decodeURIComponent(document.cookie);
  const cookieList: string[] = decodedCookieString.split(';');
  const cookie = cookieList.find(element => element.trim().startsWith(`${cookieName}=`));

  if (cookie) {
    const value = cookie.split('=')[1];
    if (value) {
      return value.split(',')[0].trim();
    }
  }
  return '';
};

export const extractAktionsNummerFromCookie = (): string =>
  extractCookieValue(AKTIONSNUMMER_COOKIENAME);

export const extractLoiTokenFromCookie = (): string => extractCookieValue(LOI_TOKEN_COOKIENAME);
